import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'custom-event-polyfill';
import 'eligrey-classlist-js-polyfill';
import '@emeritus-tech/leaky-attributes/dist/app';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import pltvAPI from 'ee-pltv';
import toggleContactCheckbox from '../../modules/iframes/toggleContactCheckbox';
import initSentry from '../../modules/sentry';
import IE11Polyfills from '../../modules/ie11/polyfills';
import bootstrapper from '../../modules/bootstrapper';
import stickyNav from '../../modules/halfsiesForm/stickyNav';
import Scroller from '../../modules/halfsiesForm/scroller';
import HalfsiesForm from '../../modules/halfsiesForm';
import PrefillForm from '../../modules/halfsiesForm/prefillForm';
import modals from '../../modules/modals';
import { isWholesiesConsentUpdateEnabled, updateConsentCopy } from '../../modules/marketing/wholesiesConsentUpdate';

IE11Polyfills();

initSentry('Landing Page Template', {
  academicInstitution: bootstrapper.academicInstitution,
  programName: bootstrapper.programName,
  customFormId: bootstrapper.customFormId,
});

const loadHandler = () => {
  var {
    customFormId,
    coursePreviewLandingPageEnabled,
    customFormRedirectPath,
    programName,
    programPrice,
  } = bootstrapper;

  // ------------------
  //  STICKY NAV
  //--------------------
  var desktopInfoBar = document.querySelector('.information');
  var desktopStickyScrollThreshold = desktopInfoBar ? desktopInfoBar.offsetTop : 650;
  var scrollThreshold = coursePreviewLandingPageEnabled
    ? 85
    : desktopStickyScrollThreshold;
  stickyNav({ scrollThreshold });

  // ------------------
  //  MODALS
  //--------------------
  modals();

  // ------------------
  //  SMOOTH SCROLLING
  //--------------------
  Scroller({
    scrollBehavior: 'smooth',
  });

  // ------------------
  //  HALFSIES FORM
  //--------------------
  var formId = 'new_custom_form_entry';
  var form = document.getElementById(formId);
  var params = window.location.search;
  if (form) {
    if (isWholesiesConsentUpdateEnabled()) {
      updateConsentCopy(form);
    }

    var halfsiesForm = new HalfsiesForm({
      afterSubmit: async (response) => {
        /*
          This hook is intended to be used to reload or redirect the page
          it is also where you will send events to facebook, or push things to the
          data layer in GTM, write to localstorage, etc...
        */
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'lead-form-submit-lead',
          courseName: programName,
          coursePrice: programPrice,
        });

        // eslint-disable-next-line no-underscore-dangle
        window._eePltvConfigV2 = {
          // eslint-disable-next-line no-underscore-dangle
          ...window._eePltvConfigV2,
        };
        var url = new URL(response.data.url);
        var entryToken = url.searchParams.get('entry_token');

        try {
          pltvAPI.initSentry(bootstrapper.sentryDsn);
          var pltvData = await pltvAPI.calculatePltv({
            urlString: window.location.href,
            uaString: window.navigator.userAgent,
            entryToken,
          });

          var {
            debug_mode: pltvDebugMode,
            pltv: pltvValue,
            default_value: pltvDefaultValue,
          } = pltvData;

          window.dataLayer.push({
            event: 'pltv-v2-purchase-event',
            pltvDebugMode,
            pltvDefaultValue,
            pltvValue,
          });
          // eslint-disable-next-line no-console
          console.log('This is the calculatePltv response', pltvData);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('There was an error on the library', error);
        } finally {
          /*
            If there is a redirect path set then use it. If not then reload the page.
          */
          if (coursePreviewLandingPageEnabled) {
            window.location.href = `${window.location.pathname}/course-preview#intro-modal`;
          } else {
            window.location.href = `${window.location.pathname}/${params}${params === '' ? '?' : '&'}thank_you=true`;
          }
        }
      },
      coursePreviewLandingPageEnabled,
      customFormId,
      customFormRedirectPath,
      form,
      formSelector: '.js-custom-form',
      host: window.location.origin,
      paramString: params,
      setUTMParams: true,
      submitButtonSelector: 'input[type=submit]',
    });

    if (coursePreviewLandingPageEnabled && window.location.hash === '#referrals-email-capture-modal') {
      window.location.hash = '#preview-course-modal';
    }

    // --------------------------
    //  PREFETCH AND PREFILL FORM
    //---------------------------

    halfsiesForm.fetch()
      .then((response) => {
        var { data: { data } } = response;
        data.course_preview = coursePreviewLandingPageEnabled;
        var allowedFields = [
          'country',
          'email',
          'first_name',
          'last_name',
          'phone',
          'work_experience',
          'group_enrollment',
        ];

        var findInput = (name) => {
          if (name === 'phone') {
            return document.querySelector('#custom_form_entry_mobile_no');
          }
          return document.querySelector(`#custom_form_entry_${name}`);
        };

        PrefillForm({
          allowedFields,
          data,
          findInput,
        });

        toggleContactCheckbox();

        if (!coursePreviewLandingPageEnabled) {
          var workExperienceSelect = document.querySelector('select[id="custom_form_entry_work_experience"]');
          var countrySelect = document.querySelector('select[id="custom_form_entry_country"]');

          if (workExperienceSelect) {
            workExperienceSelect.options[0].textContent = 'Work Experience';
            workExperienceSelect.options[0].disabled = true;
          }

          if (countrySelect) {
            countrySelect.options[0].textContent = 'Country';
            countrySelect.options[0].disabled = true;
          }
        }
      });
  }
};


if (document.readyState === 'loading') {
  // loading hasn't finished yet so it is ok to listen for domcontentloaded
  document.addEventListener('DOMContentLoaded', loadHandler);
} else {
  loadHandler();
}
